export const TIERS = {
  stereo8: {
    key: "stereo8",
    name: "Stereo 8",
    tagline: "The everyday standard.",
    priceId: null,
    tapeLimit: 25,
    photoLimit: 1,
    listingLimit: 3,
    exportFormats: [],
    wishlistAlerts: false,
    verifiedBadge: false,
    featuredListings: false,
  },
  quad8: {
    key: "quad8",
    name: "Quad-8",
    tagline: "The rare, upgraded format.",
    priceId: process.env.REACT_APP_STRIPE_PRICE_QUAD8,
    tapeLimit: 250,
    photoLimit: 5,
    listingLimit: 15,
    exportFormats: ["csv"],
    wishlistAlerts: true,
    verifiedBadge: true,
    featuredListings: false,
  },
  vaultReserve: {
    key: "vaultReserve",
    name: "Vault Reserve",
    tagline: "The Vault's own top-shelf tier.",
    priceId: process.env.REACT_APP_STRIPE_PRICE_VAULT_RESERVE,
    tapeLimit: Infinity,
    photoLimit: Infinity,
    listingLimit: Infinity,
    exportFormats: ["csv", "pdf"],
    wishlistAlerts: true,
    verifiedBadge: true,
    featuredListings: true,
  },
};

export function getTier(tierKey) {
  return TIERS[tierKey] || TIERS.stereo8;
}

// Vault Supreme is an add-on, not a base tier: it's billed as a second, independent
// subscription layered on top of Quad-8 or Vault Reserve, so it isn't part of TIERS.
export const SUPREME_ADDON = {
  key: "supreme",
  name: "Vault Supreme",
  tagline: "Play what you collect — player marketplace and repair directory.",
  priceId: process.env.REACT_APP_STRIPE_PRICE_SUPREME,
};

export const SUPREME_ELIGIBLE_TIERS = ["quad8", "vaultReserve"];

export function isSupremeEligible(profile) {
  return SUPREME_ELIGIBLE_TIERS.includes(profile?.subscriptionTier)
    && (profile?.subscriptionStatus === "active" || profile?.subscriptionStatus === "trialing");
}

export function isSupremeActive(profile) {
  return profile?.supremeStatus === "active" || profile?.supremeStatus === "trialing";
}
